/**
 *  Others Exports
 */
import _, { isEmpty } from 'lodash';
import { iconsList } from '../../../components/icons/agyle';
import Notes from '../../../util/notes';
import config from '../../../app/config';

export const createNote = (icon, patient, type) => {
    //  Prepare status
    let searchIcon;
    if (patient && patient.flags) {
        searchIcon = _.find(patient.flags, { name: icon.name });
    }

    if (!searchIcon) {
        searchIcon = {
            name: icon.name,
            value: icon.statusesCount - 1,
        };
    } else {
        searchIcon = {
            value: searchIcon.value - 1,
        };
    }

    // Add description
    let display = _.find(iconsList, { name: icon.name });
    display = display ? display.display : icon.name;
    searchIcon = {
        ...searchIcon,
        description: display,
    };

    const action =
        searchIcon.value === 2 ? 'requested' : searchIcon.value === 1 ? (icon.statusesCount === 3 ? 'completed' : 'requested') : 'removed';
    return Notes.getIconsNote(type, searchIcon.description, action);
};

export const getReferralsColor = (ecdsObj) => {
    if (ecdsObj) {
        let color = config.referralsColors[ecdsObj.group ? ecdsObj.group : ecdsObj.type];
        if (!_.isEmpty(config.referralsColors.exceptions)) {
            const find = _.find(config.referralsColors.exceptions, { code: ecdsObj.snomedCode ? ecdsObj.snomedCode : ecdsObj.c });
            color = find ? find?.color : color;
        }
        return color;
    }
};

export const getTaskTextFoTooltip = (studies) => {
    const plans = [
        { key: 'medicalPlan', title: 'Medical Plan' },
        { key: 'nursingPlanNote', title: 'Nursing Plan' },
        { key: 'treatmentPlan', title: 'Treatment Plan' },
    ];

    const sections = plans
        .map(({ key, title }) => {
            const plan = studies?.[key];
            if (isEmpty(plan?.notes)) return null;

            const notesText = plan.notes.map((note) => `${note.checked ? '✓' : '✗'} ${note.text}`).join('\n');

            return `${title}\n${notesText}`;
        })
        .filter(Boolean);

    return sections.length > 0 ? sections.join('\n\n') : 'No Actions';
};
